/**
 * VISALL DataProcessor 对外API
 * 轻量级兼容层，内部使用新DataProcessor引擎
 */

import { DataProcessor } from '../core/dataProcessor/DataProcessor';
import type { Data, Spec, LayerSpec } from '../core/dataProcessor/types';

/**
 * ✅ 向后兼容的预处理函数
 * 内部使用新的DataProcessor引擎
 */
export default function preprocessing(data: Data, spec: Spec): boolean {
  try {
    const processor = DataProcessor.getInstance();
    const result = processor.validateAndProcess(data, spec);

    // 保持与旧API相同的行为：设置__isEncodingValid标记
    spec.layers.forEach((layer: LayerSpec) => {
      const layerResult = result.layerResults.get(layer.type);
      // eslint-disable-next-line no-param-reassign
      layer.__isEncodingValid = layerResult?.isValid ?? false;
    });

    return result.isValid;
  } catch (error) {
    console.error('DataProcessor validation failed:', error);
    return false;
  }
}

// 保持类型兼容性
export type { Data, Spec };
